import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import api from './authService';

let echoInstance = null;
let cachedToken = null;

const apiBaseUrl = () =>
  (process.env.REACT_APP_API_URL || 'https://api.vendalist.com/api').replace(/\/$/, '');


export const isEchoConfigured = () => Boolean(process.env.REACT_APP_REVERB_APP_KEY);

export const disconnectEcho = () => {
  if (echoInstance) {
    echoInstance.disconnect();
    echoInstance = null;
  }
  cachedToken = null;
};

export const getEcho = () => {
  if (!isEchoConfigured()) {
    return null;
  }

  const token = typeof localStorage !== 'undefined' ? localStorage.getItem('token') : null;
  if (!token) {
    return null;
  }

  if (echoInstance && cachedToken !== token) {
    disconnectEcho();
  }

  if (echoInstance) {
    return echoInstance;
  }

  window.Pusher = Pusher;

  const scheme = process.env.REACT_APP_REVERB_SCHEME || 'http';
  const host = process.env.REACT_APP_REVERB_HOST || 'localhost';
  const port = Number(process.env.REACT_APP_REVERB_PORT || 8080);

  cachedToken = token;

  echoInstance = new Echo({
    broadcaster: 'reverb',
    key: process.env.REACT_APP_REVERB_APP_KEY,
    wsHost: host,
    wsPort: port,
    wssPort: port,
    forceTLS: scheme === 'https',
    enabledTransports: ['ws', 'wss'],
    authEndpoint: `${apiBaseUrl()}/broadcasting/auth`,
    authorizer: (channel) => ({
      authorize: (socketId, callback) => {
        api
          .post('/broadcasting/auth', {
            socket_id: socketId,
            channel_name: channel.name,
          })
          .then((response) => callback(false, response.data))
          .catch((error) => callback(true, error));
      },
    }),
  });

  return echoInstance;
};

export const bookingChatChannelName = (bookingId) => `booking.${bookingId}.chat`;
